import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faYoutube, faLinkedinIn, faGithub, faCcPaypal } from '@fortawesome/free-brands-svg-icons';

export default function SocialMediaRow(){
    const aTagStyle = {
        color: "white",
    }
    const githubUrl = "https://github.com/brilliant-ember";
    const linkedinUrl = "https://www.linkedin.com/in/moala/";
    const youTubeUrl= "https://www.youtube.com/user/FireSymphoney";
    const igUrl = "https://www.instagram.com/brilliant_ember/";
    const paypalDonation = "https://paypal.me/ShukranThanksMerci?locale.x=en_US";
    return (
        <Row className="my-5 mx-1 justify-content-md-center">
         <Col><a href={igUrl} style = {aTagStyle}> <FontAwesomeIcon size="3x"  icon={faInstagram} /></a></Col>
         <Col><a style={aTagStyle} href={paypalDonation}><FontAwesomeIcon size="3x"  icon={faCcPaypal} /></a></Col>
         <Col><a style={aTagStyle} href={githubUrl}><FontAwesomeIcon size="3x"  icon={faGithub} /></a></Col>
         <Col><a href={linkedinUrl} style = {aTagStyle}><FontAwesomeIcon size="3x"  icon={faLinkedinIn} /></a></Col>
         <Col><a href={youTubeUrl} style = {aTagStyle}><FontAwesomeIcon size="3x"  icon={faYoutube} /></a></Col>
         
         </Row>
    );
}